<template>
    <v-layout row wrap>
        <v-flex v-if="expirationDateAvailable" xs12 sm8 pr-1>
            <v-text-field
                v-model="expirationMetadata"
                :placeholder="getPlaceholder"
                :outlined="outlined"
                :label="getExpirationLabel"
                :disabled="disabled"
                pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
                :rules="[
                    !isNamExpirationRequired ||
                        requiredField(), v => !v || !v.split('-') || !v.split('-')[1] ||
                        getFormRule('validMonth')(v.split('-')[1])
                ]"
                name="nam-expiration-date"
                :data-meta-id="getNamExpirationMetadata.id"
                data-testid="nam-expiration-date-input"
                :required="isNamExpirationRequired"
                v-mask="'####-##'"
                id="nam-expiration-date"
                @input="validateAndEmitExpiration"
            />
        </v-flex>
        <v-flex v-if="sequentialAvailable" xs12 sm4 pr-1>
            <v-text-field
                v-model="sequentialMetadata"
                :placeholder="'##'"
                :outlined="outlined"
                :label="getSequentialLabel"
                :disabled="disabled"
                :rules="[ !isNamSequentialRequired || requiredField() ]"
                :required="isNamSequentialRequired"
                :data-meta-id="getNamSequentialMetadata.id"
                data-testid="nam-sequential-number-input"
                v-mask="'##'"
                id="nam-sequential"
                @input="emitSequentialValue"
            />
        </v-flex>
        <v-flex xs12>
            <v-alert
                :value="shouldDisplayWarning"
                color="warning"
                icon="warning"
                outlined
                data-testid="nam-expiration-warning"
                v-text="$t('form.warningNamExpired')" />
        </v-flex>
    </v-layout>
</template>
<script>
import { isPast } from 'date-fns';
import { find, get } from 'lodash';
import { MetadataEnum } from '@/enums';
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';

export default {
    name: 'nam-expiration-sequential',
    mixins: [formRules],
    props: {
        otherMetadata: { type: Array, required: true },
        disabled: { type: Boolean, required: false, default: false },
        outlined: { type: Boolean, required: false, default: true },
        computedRequired: { type: Boolean, require: true },
    },
    data() {
        return {
            sequentialMetadata: '',
            expirationMetadata: '',
        };
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
            getBaseMetadataById: 'services/getBaseMetadataById',
        }),
        getExpirationLabel() {
            return (this.isNamExpirationRequired ? '* ' : '') +
                this.getBaseMetadataById(MetadataEnum.NAM_EXPIRATION_DATE)[`description${this.upperLocale}`];
        },
        getSequentialLabel() {
            return (this.isNamSequentialRequired ? '* ' : '') +
                this.getBaseMetadataById(MetadataEnum.NAM_SEQUENTIAL_NUMBER)[`description${this.upperLocale}`];
        },
        getNamExpirationMetadata() {
            return find(this.otherMetadata, ['metadata', MetadataEnum.NAM_EXPIRATION_DATE]);
        },
        getNamSequentialMetadata() {
            return find(this.otherMetadata, ['metadata', MetadataEnum.NAM_SEQUENTIAL_NUMBER]);
        },
        expirationDateAvailable() {
            return get(this.getNamExpirationMetadata, 'status', 0) === 1;
        },
        sequentialAvailable() {
            return get(this.getNamSequentialMetadata, 'status', 0) === 1;
        },
        isNamSequentialRequired() {
            return this.computedRequired && get(this.getNamSequentialMetadata, 'isOverride', false);
        },
        isNamExpirationRequired() {
            return this.computedRequired && get(this.getNamExpirationMetadata, 'isOverride', false);
        },
        isExpirationMetadataFilled() {
            return this.expirationMetadata.length >= 7;
        },
        isDateExpired() {
            return isPast(this.expirationMetadata);
        },
        shouldDisplayWarning() {
            return this.isExpirationMetadataFilled && this.isDateExpired;
        },
        getPlaceholder() {
            return this.locale === 'fr' ? 'AAAA-MM' : 'YYYY-MM';
        },
    },
    methods: {
        validateAndEmitExpiration() {
            if (!this.isExpirationMetadataFilled) return;
            this.$emit('updateOtherMetadata', {
                metadata: this.getNamExpirationMetadata,
                value: this.expirationMetadata,
            });
        },
        emitSequentialValue() {
            this.$emit('updateOtherMetadata', {
                metadata: this.getNamSequentialMetadata,
                value: this.sequentialMetadata,
            });
        },
    },
};
</script>
